import { render, staticRenderFns } from "./text-analysis.vue?vue&type=template&id=66e2bf32&scoped=true"
import script from "./text-analysis.ts?vue&type=script&lang=ts&external"
export * from "./text-analysis.ts?vue&type=script&lang=ts&external"
import style0 from "./text-analysis.less?vue&type=style&index=0&id=66e2bf32&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2bf32",
  null
  
)

export default component.exports